// Static lists the browser needs, mirrored from src/lib/constants.ts.
//
// Event editions are NOT mirrored here: Ruby owns them (config/initializers/events.rb,
// PORTING.md G6) and controllers pass the edition a page needs as a prop.

export const SITE_URL = 'https://hack.platan.us';
export const GITHUB_ORG = 'platanus-hack';

/**
 * Default arcade cabinet keyboard mapping
 * Maps arcade control codes (e.g., 'P1_U', 'P1_1') to keyboard keys or mouse actions
 *
 * Supported values:
 * - Keyboard keys: 'w', 'a', 's', 'd', 'space', 'Enter', 'ArrowUp', etc.
 * - Mouse actions: 'click' or 'leftclick', 'rightclick', 'middleclick'
 */
export const DEFAULT_ARCADE_MAPPING: Record<string, string> = {
  // Player 1 - Direction
  P1_U: 'w',
  P1_D: 's',
  P1_L: 'a',
  P1_R: 'd',
  // Player 1 - Buttons
  P1_1: 'u',
  P1_2: 'i',
  P1_3: 'o',
  P1_4: 'j',
  P1_5: 'k',
  P1_6: 'l',
  // Player-1 start defaults to Enter: the common game template binds START1 to
  // 'Enter', and no submitted game relies solely on '1'. The cabinet drives
  // games through the virtual-control path (HID controllers / on-screen pad),
  // which dispatches this key, so START1 now matches what games actually read.
  START1: 'Enter',
  // Player 2 - Direction
  P2_U: 'ArrowUp',
  P2_D: 'ArrowDown',
  P2_L: 'ArrowLeft',
  P2_R: 'ArrowRight',
  // Player 2 - Buttons
  P2_1: 'r',
  P2_2: 't',
  P2_3: 'y',
  P2_4: 'f',
  P2_5: 'g',
  P2_6: 'h',
  START2: '2',
};

export const COUNTRIES = [
  // LATAM - Chile first
  { code: 'CL', name: 'Chile', emoji: '🇨🇱' },
  { code: 'AR', name: 'Argentina', emoji: '🇦🇷' },
  { code: 'BO', name: 'Bolivia', emoji: '🇧🇴' },
  { code: 'BR', name: 'Brazil', emoji: '🇧🇷' },
  { code: 'CO', name: 'Colombia', emoji: '🇨🇴' },
  { code: 'CR', name: 'Costa Rica', emoji: '🇨🇷' },
  { code: 'CU', name: 'Cuba', emoji: '🇨🇺' },
  { code: 'DO', name: 'Dominican Republic', emoji: '🇩🇴' },
  { code: 'EC', name: 'Ecuador', emoji: '🇪🇨' },
  { code: 'SV', name: 'El Salvador', emoji: '🇸🇻' },
  { code: 'GT', name: 'Guatemala', emoji: '🇬🇹' },
  { code: 'HN', name: 'Honduras', emoji: '🇭🇳' },
  { code: 'MX', name: 'Mexico', emoji: '🇲🇽' },
  { code: 'NI', name: 'Nicaragua', emoji: '🇳🇮' },
  { code: 'PA', name: 'Panama', emoji: '🇵🇦' },
  { code: 'PY', name: 'Paraguay', emoji: '🇵🇾' },
  { code: 'PE', name: 'Peru', emoji: '🇵🇪' },
  { code: 'PR', name: 'Puerto Rico', emoji: '🇵🇷' },
  { code: 'UY', name: 'Uruguay', emoji: '🇺🇾' },
  { code: 'VE', name: 'Venezuela', emoji: '🇻🇪' },
  // Other countries
  { code: 'US', name: 'United States', emoji: '🇺🇸' },
  { code: 'CA', name: 'Canada', emoji: '🇨🇦' },
  { code: 'ES', name: 'Spain', emoji: '🇪🇸' },
  { code: 'PT', name: 'Portugal', emoji: '🇵🇹' },
  { code: 'FR', name: 'France', emoji: '🇫🇷' },
  { code: 'DE', name: 'Germany', emoji: '🇩🇪' },
  { code: 'IT', name: 'Italy', emoji: '🇮🇹' },
  { code: 'NL', name: 'Netherlands', emoji: '🇳🇱' },
  { code: 'GB', name: 'United Kingdom', emoji: '🇬🇧' },
  { code: 'TR', name: 'Turkey', emoji: '🇹🇷' },
  { code: 'IN', name: 'India', emoji: '🇮🇳' },
  { code: 'SG', name: 'Singapore', emoji: '🇸🇬' },
  { code: 'CN', name: 'China', emoji: '🇨🇳' },
  { code: 'DK', name: 'Denmark', emoji: '🇩🇰' },
  { code: 'OTHER', name: 'Other', emoji: '🌍' },
] as const;
